import { Docs } from "../../lib";
import React from "react";

export default () => (
  <Docs label="Demo" description="I'm in a Showcase!" />);



// WEBPACK FOOTER //
// ./src/Docs/demo/NoProps.js